import script from "./AddTask.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddTask.vue?vue&type=script&setup=true&lang=ts"

import "./AddTask.vue?vue&type=style&index=0&id=03144560&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03144560"]])

export default __exports__